export const COURT_LIST_REQUEST = "COURT_LIST_REQUEST";
export const COURT_LIST_SUCESS = "COURT_LIST_SUCESS";
export const COURT_LIST_FAIL = "COURT_LIST_FAIL";
export const COURT_SCHEDULE_LIST = "COURT_SCHEDULE_LIST";
